import { Mail } from 'lucide-react';

export const DUREE_LABELS = { '1m': '1 mois', '2m': '2 mois', '6m': '6 mois', '12m': '12 mois' };

/**
 * Render the "Participant / Invité" cell of a code row, with a small
 * "(modifié)" marker when the participant's active email differs from the
 * owner's invitation — tooltip explains both values.
 */
export function ParticipantCell({ c }) {
    const inv    = c.email_invitation || null;
    const partEm = c.participant_email || null;
    const active = partEm || inv;
    const modified = partEm && inv && partEm.toLowerCase() !== inv.toLowerCase();
    const name = c.participant_name;
    const tooltipLines = [];
    if (inv) tooltipLines.push(`Invité à ${inv}`);
    if (partEm) tooltipLines.push(`Email actif : ${partEm}`);
    const tooltip = tooltipLines.join(' · ');

    if (name) {
        return (
            <span title={tooltip}>
                {name}
                {modified && <span style={{ marginLeft: 5, fontSize: '0.72em', padding: '0 5px', borderRadius: 3, background: 'rgba(245, 158, 11, 0.15)', color: '#b45309' }} title={tooltip}>modifié</span>}
            </span>
        );
    }
    if (!active) return <span style={{ opacity: 0.3 }}>&mdash;</span>;
    return (
        <span style={{ color: 'var(--text-muted)' }} title={tooltip}>
            <Mail size={11} style={{ verticalAlign: 'middle', marginRight: 3 }} />
            {active.split('@')[0]}
            {modified && <span style={{ marginLeft: 5, fontSize: '0.72em', padding: '0 5px', borderRadius: 3, background: 'rgba(245, 158, 11, 0.15)', color: '#b45309' }}>modifié</span>}
        </span>
    );
}

/**
 * Split a list of quiz_code / category_code rows into 3 buckets :
 *   - active    : AVAILABLE or IN_PROGRESS, sorted by created_at DESC
 *   - finished  : FINISHED, sorted by finished_at DESC (latest first)
 *   - archived  : EXPIRED / REVOKED, at the bottom
 * Used to render a visual split inside each group (sujet / catégorie).
 */
export function splitCodesByStatus(codes) {
    const active = [];
    const finished = [];
    const archived = [];
    (codes || []).forEach(c => {
        if (c.status === 'AVAILABLE' || c.status === 'IN_PROGRESS') active.push(c);
        else if (c.status === 'FINISHED') finished.push(c);
        else archived.push(c);
    });
    active.sort((a, b) => String(b.created_at || '').localeCompare(String(a.created_at || '')));
    finished.sort((a, b) => {
        // latest-finished first ; fallback on last_child_finished_at for category_codes
        const da = a.finished_at || a.last_child_finished_at || a.created_at || '';
        const db = b.finished_at || b.last_child_finished_at || b.created_at || '';
        return String(db).localeCompare(String(da));
    });
    return { active, finished, archived };
}
